export default __webpack_public_path__ + "static/media/Vambraces of the Black Dragon.6719e5dd.jpg";